// extracted by mini-css-extract-plugin
module.exports = {"Contact":"ContactSupportIcon_Contact__14kMN","ContactIcon":"ContactSupportIcon_ContactIcon__FYe_e","ContactText":"ContactSupportIcon_ContactText__2oeTG"};